import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from "src/app/shared/services/security.service";
import { DocumentoService } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';

interface IHeaderForm {
  observaciones: string
}

@Component({
  selector: 'app-empresas-recibidos-modal-observaciones-no-procesadas',
  templateUrl: './modal-observaciones-no-procesadas.component.html',
  styleUrls: ['../../empresas-recibidos.component.scss']
})
export class EmpresasRecibidosModalObservacionesNoProcesadasComponent implements OnInit {

  @Input() relativeId: string = ''

  @ViewChild('observacionesNoProcesadaModal', { static: true }) modalObservaciones: ModalDirective;
  @Output() onResponse: EventEmitter<any> = new EventEmitter()

  // Constants

  // Form
  formData: FormGroup;
  initialValues: IHeaderForm

  // Callbacks
  private rutEmpresa: number
  private sucursalCodigo: number
  private rutUsuario: number
  public createPayloadSeleccionados: Array<any> = []
  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private documentoService: DocumentoService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('EMPRESAS-RECIBIDOS-OBSERVACIONES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    this.createFormInitialValues()
    this.createForms()
  }

  createFormInitialValues() {
    this.initialValues = {
      observaciones: null,
    }
  }

  private createForms() {
    this.formData = this.fb.group({
      observaciones: [null, [Validators.required, Validators.maxLength(300)]],
    });
  }

  show(lista: any) {
    // this.acceptCallback = acceptCallback
    // this.additionalData = additionalData
    this.setInitialValues()
    this.createPayloadSeleccionados = lista
    this.modalObservaciones.show()
  }

  hide() {
    this.cleanAll()
    this.modalObservaciones.hide();
  }

  private setInitialValues() {
    this.formValidatorsService.setInitialState(this.formData, this.initialValues)
  }

  agregarObservacion() {
    const listaSelecionados = this.createPayloadSeleccionados
    this.log('listaSelecionados', listaSelecionados)

    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        rut_usuario: this.rutUsuario,
        observacion: this.formData.get("observaciones").value === null ? '' : this.formData.get("observaciones").value,
      },
      lista: listaSelecionados
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoService.marcaDocumentoCompraNoProcesado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null && respuesta !== undefined
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastService.success('Operación realizada')
      this.onResponse.emit()
      this.hide()
    })

  }

  public cleanAll() {
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()
    this.createPayloadSeleccionados = []
    this.initializeFormData()
  }

  private initializeFormData() {
    this.formData.get("observaciones").setValue(null)
  }
}
